/* eslint-disable indent */
import { StoreActions } from '@src/store';

import type { OrderStoreState } from './index';
import { OrderActionTypes } from './index';

export type OrderStoreReducer = (
  state: OrderStoreState,
  action: StoreActions
) => OrderStoreState;

export const orderStoreReducer: OrderStoreReducer = (state, action) => {
  switch (action?.type) {
    case OrderActionTypes.SetOrder:
      return {
        ...state,
        order: action.payload,
      };
    case OrderActionTypes.SetOrderSubmitData:
      return {
        ...state,
        orderSubmitData: action.payload,
      };
    case OrderActionTypes.SetOrderInitData:
      return {
        ...state,
        orderInitData: action.payload,
      };
    case OrderActionTypes.SetOrderPageTitle:
      return {
        ...state,
        orderPageTitle: action.payload,
      };
    case OrderActionTypes.SetOrderRequestData:
      return {
        ...state,
        orderRequestData: action.payload,
      };
    case OrderActionTypes.SetCachedOrderRequestData:
      return {
        ...state,
        cachedOrderRequestData: action.payload,
      };
    case OrderActionTypes.SetSubscriptionId:
      return {
        ...state,
        subscriptionId: action.payload,
      };
    case OrderActionTypes.SetCompletePaymentData:
      return {
        ...state,
        completePaymentData: action.payload,
      };
    case OrderActionTypes.SetHasSpecialOffersConsent:
      return {
        ...state,
        hasSpecialOffersConsent: action.payload,
      };
    case OrderActionTypes.SetThemeValue:
      return {
        ...state,
        themeValue: action.payload,
      };
    default:
      return state;
  }
};
